import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  label: {
    fontFamily: "Cairo",
    fontWeight: 400,
    fontSize: "16px",
    color: "#2A3333",
  },
  patientDataLineOneDropDownStyle: {
    marginTop: "7px",
    height: "56px",
    borderRadius: "4px",
    background: "#fff",
    bborder: "1px solid #C6C9CA",
  },
  textEnabled: {
    background: "#FFF",
    width: "102%",
  },
  textEnabledSelect: {
    background: "#FFF",
    width: "100%",
    marginTop: "8px",
  },
}));
